import { FunctionComponent } from 'react'
import { Location, useLocation } from 'react-router-dom'
import DaycareList from './daycareList/daycareList'
import DaycareProfileHandler from './daycareProfile/DaycareProfileHandler'

const Daycare: FunctionComponent = () => {
    const urlDaycare: Location = useLocation()
    const paramDaycare: URLSearchParams = new URLSearchParams(urlDaycare.search)
    const daycareId: number = Number(paramDaycare.get('daycare') || '0')

    return daycareId === 0 ? <DaycareList /> : <DaycareProfileHandler daycareId={daycareId} />
}

export default Daycare
